export var Action = /*#__PURE__*/ function(Action) {
    Action["Create"] = "CREATE";
    Action["Update"] = "UPDATE";
    Action["Delete"] = "DELETE";
    Action["Shift"] = "SHIFT";
    Action["Duplicate"] = "DUPLICATE";
    Action["Refresh"] = "REFRESH";
    Action["Bulk"] = "BULK";
    Action["Patch"] = "PATCH";
    return Action;
}({});
export var ObjectType = /*#__PURE__*/ function(ObjectType) {
    ObjectType["Task"] = "TASK";
    ObjectType["User"] = "USER";
    ObjectType["Users"] = "USERS";
    ObjectType["Team"] = "TEAM";
    ObjectType["Field"] = "FIELD";
    ObjectType["Comment"] = "COMMENT";
    ObjectType["ConversationComment"] = "CONVERSATION_COMMENT";
    ObjectType["Project"] = "PROJECT";
    ObjectType["ProjectConversation"] = "PROJECT_CONVERSATIONS";
    ObjectType["ProjectPhase"] = "PROJECT_PHASE";
    ObjectType["Notification"] = "NOTIFICATION";
    ObjectType["Attachment"] = "ATTACHMENT";
    ObjectType["AttachmentAssociation"] = "ATTACHMENT_ASSOCIATION";
    ObjectType["Document"] = "DOCUMENT";
    ObjectType["DocumentComment"] = "DOCUMENT_COMMENT";
    ObjectType["Approvals"] = "APPROVALS";
    ObjectType["Space"] = "SPACE";
    ObjectType["ProjectMembers"] = "PROJECT_MEMBERS";
    ObjectType["ProjectMembersV2"] = "PROJECT_MEMBERS_V2";
    ObjectType["TimesheetComment"] = "TIMESHEET_COMMENT";
    ObjectType["ResourceAllocation"] = "RESOURCE_ALLOCATION";
    ObjectType["AccountMembers"] = "ACCOUNT_MEMBERS";
    ObjectType["ProjectSpace"] = "PROJECT_SPACE";
    ObjectType["SpaceTab"] = "SPACE_TAB";
    ObjectType["AsyncProcessor"] = "ASYNC_PROCESSOR";
    ObjectType["ConversationReadReceipt"] = "CONVERSATION_COMMENT_READ_RECEIPT";
    ObjectType["Sprint"] = "SPRINT";
    ObjectType["ResourceRequest"] = "RESOURCE_REQUEST";
    ObjectType["Invoice"] = "INVOICE";
    ObjectType["InvoiceConversation"] = "INVOICE_CONVERSATION";
    ObjectType["ProjectFinanicalField"] = "FINANCIAL";
    ObjectType["Form"] = "FORM";
    ObjectType["Company"] = "COMPANY";
    ObjectType["TimeEntry"] = "TIME_ENTRY";
    ObjectType["Epic"] = "EPIC";
    ObjectType["Backlog"] = "BACKLOG";
    ObjectType["TimeEntryBulkAction"] = "TIME_ENTRY_BULK_ACTION";
    ObjectType["Expense"] = "EXPENSE";
    ObjectType["SheetTab"] = "SHEET_TAB";
    ObjectType["ExpenseReport"] = "EXPENSE_REPORT";
    ObjectType["RevenueEntry"] = "REVENUE_ENTRY";
    ObjectType["RevenueEntryBulkAction"] = "REVENUE_ENTRY_BULK_ACTION";
    ObjectType["FinancialsBudgetMembers"] = "FINANCIALS_BUDGET_MEMBER";
    ObjectType["ProjectFinancialBudget"] = "PROJECT_FINANCIALS_BUDGET";
    ObjectType["Metering"] = "METERING";
    return ObjectType;
}({});
export var ObjectEventType = /*#__PURE__*/ function(ObjectEventType) {
    ObjectEventType["Individual"] = "INDIVIDUAL";
    ObjectEventType["Batch"] = "BATCH";
    return ObjectEventType;
}({});
export const EventType = (action, type)=>[
        action,
        type
    ];
